import React from "react"
import "./ShippingMethod.css"
import ShippingForm from "./ShippingForm"
import CheckSteps from "../CheckSteps"

function ShippingMethod(props) {
  return (
    <div className="ShippingMethod">
      <CheckSteps
        steps={props.steps}
        setSteps={props.setSteps}
        value="shipping"
      />
      <h1>Shipping Method</h1>
      <ShippingForm {...props} />
    </div>
  )
}

export default ShippingMethod
